import * as datastore from '@/datastore'

export interface List extends datastore.Reference {
	name: string
}

export const defaultList: Readonly<List> = {
	$id: '',
	name: '',
}
